import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CloseStreamComponent } from '../close-stream/close-stream.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-init-stream-view',
    standalone: false,
    templateUrl: './init-stream-view.component.html',
    styleUrl: './init-stream-view.component.scss'
})
export class InitStreamViewComponent implements OnInit {
    dia = inject(MatDialogRef<InitStreamViewComponent>);
    data: { title: string, data: { name: string, description: string }[] } = inject(MAT_DIALOG_DATA);
    router = inject(Router);
    private destroyRef = inject(DestroyRef);

    constructor(private dialog: MatDialog) { }

    ngOnInit(): void {
        this.dia.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        this.close();
                    } else if (event.key === 'Escape') {
                        event.preventDefault();
                        this.closeStream();
                    }
                },
            });
    }

    close() {
        this.dia.close("start")
    }
    goHome() {
        this.router.navigate(['/home/user']);
        this.dia.close("cancel")
    }

    async closeStream() {
        let dia2 = await this.dialog.open(CloseStreamComponent, {
            panelClass: 'small-dialog',
        }
        );

        dia2.afterClosed().subscribe((result) => {
            if (result === true) {
                this.goHome();
            }
        })
    }

}

